const GOOLE_MAP_API_KEY = window.GOOGLE_MAP_API_KEY;

export {GOOLE_MAP_API_KEY};